module.exports = __webpack_public_path__ + "img/pointB_roundline.f9a6d3b9.svg";